export default {
  translation: {
    //General
    back: 'Back',
    skip: 'Skip',
    retry: 'Retry',
    refresh: 'Refresh',
    reconnect: 'Reconnect',
    reconnecting: 'Reconnecting',
    reload: 'Reload',
    open: 'Open',
    close: 'Close',
    ok: 'Ok',
    cancel: 'Cancel',
    save: 'Save',
    continue: 'Continue',
    delete: 'Delete',
    on: 'on',
    at: 'at',

    //Menu
    SEARCH: 'Search',
    HOME: 'Home',
    SPECIAL: 'Special',
    SELECTED: 'Specials',
    FAVORITES: 'Favorites',
    SPORTS: 'Sports',
    CATALOGUE: 'Catalogue',
    CALENDAR: 'Calendar',
    SETTINGS: 'Settings',
    PROFILE: 'Profile',
    FOCUS: 'Pay per View',
    OFFERS: 'Offers',
    SETTINGS_EDIT_SPORTS: 'Sports',
    SETTINGS_EDIT_BROADCASTERS: 'Channels',
    SETTINGS_SUBSCRIPTIONS: 'Credits',
    SETTINGS_MANAGE_ACCOUNT: 'Manage account & subscriptions',
    SETTINGS_DELETE_ACCOUNT: 'Delete my account',
    SETTINGS_LOGIN: 'Login',
    SETTINGS_LOGOUT: 'Logout',
    SETTINGS_ACCOUNT: 'Account',
    SETTINGS_REGION: 'Region',
    SETTINGS_DEVELOPER: 'Developer',
    SETTINGS_SYS_INFO: 'System Information',
    SETTINGS_PLAYBACK: 'Playback',
    SETTINGS_IMPRINT: 'Imprint',
    SETTINGS_DATA_PRIVACY: 'Data Privacy',
    PREDICT: 'Predict',
    SETTINGS_TERMS_CONDITIONS: 'Terms & Conditions',
    SETTINGS_COOKIE_BANNER: 'Cookie Banner',
    SMART_PREVIEW: 'Smart Preview',
    EVENT_PAGE: 'Detail page',
    MORE: 'More',
    emptySubMenu: 'There is nothing to see here.',

    //Settings
    yourCreditWallets: 'Your Sportworld-Credit balance',
    creditsInfo: `Sportworld credits are your flexible prepaid credit that you can use to buy specific live sports events — without any subscription obligations. Discover what you want to see and only pay for what you really use! You can buy your Sportworld credits in the 'Offers' section in the navigation`,
    promotionsInfo: 'Promotions credits ...',
    editSports: 'My Sports',
    selectProviers: 'Select the sport categories you are interested in the Sportworld.',
    editBroadcasters: 'My Channels',
    selectBroadcasters: 'Select the sport providers and channels that you want to see in the Sportworld.',

    //Welcome
    worldOfSportsInApp: 'The diversity of sports in one app',
    startSportworld: 'Start Sportworld',
    voucherDescription: 'With the purchase of this Samsung TV you are entitled to get a free trial of Sportsworld',
    voucherTitle: 'Get it now!',
    availableForPhone:
      'Did you know? The Sportworld is also available for your phone. Get the Sportworld-app for your smartphone and enjoy many additional features as well as an innovative live sport experience.',
    orSkip: 'or skip login and start now',

    //Close App
    exitApp: 'Exit App',
    aboutClosing1: `You're about to close the Sportworld app.`,
    aboutClosing2: `Are you sure you want to leave?`,
    goBack: 'Go Back',
    leaveApp: 'Leave App',

    //Dialog
    confirmOpenAppIdTitle: 'Switching to ',
    anotherApp: 'another app',
    confirmOpenAppIdDescription1: 'You are about to open the',
    confirmOpenAppIdDescription2: ' ',

    //EventHeading
    eventOver: 'The event has already finished.',
    nowLive: 'Now live',
    liveToday: 'Live Today',

    //Silder
    noEvents: 'Currently no events here. Check back later.',
    live: 'Live',
    liveTV: 'Live TV',
    upcomingLive: 'Upcoming-live',
    premiumPass: 'Pass',
    programInfoOnly: 'Program info',
    bought: 'Bought',
    viewAll: 'View All',
    viewMore: 'View More',

    //VideoPlayer
    needSub: 'You need a Sportworld subscription to watch this channel.',
    channels247: '24/7 Channels',
    pressBack: 'Back',
    showLiveEvents: 'Show live events',
    videoContentUnavailable: 'This video content is currently not available.',
    streamUnavailable: 'This stream is currently not available.',
    ad: 'Advertisement',
    adProgress: '{{currentAdIndex}} of {{adsNumber}}',
    eventVideoOver: 'The event is over.',
    eventVideoOver2: 'We hope you enjoyed the event.',
    mediaVideoOver: 'The video is over.',
    mediaVideoOver2: 'We hope you enjoyed the video.',
    eventStartsSoon: 'Event starts soon',

    //Notification
    setReminder: 'Set reminder',
    removeReminder: 'Remove reminder',
    eventStartMessage: 'The event has started. Tap on the notification to watch the event.',
    enableNotifications:
      'Your notifications are disabled. To get reminders, you need to allow notifications from Sportworld in your settings.',
    eventStarts: 'Sportworld Reminder ⏰ Your event starts now',

    //Share link
    shareLinkTitle: 'Trust me, you don’t want to miss this – check it out on Sportworld now!',
    shareText: 'Watch this event!',
    shareLink: 'Share',

    //Watch Now Button
    watchNow: 'Watch now',
    playNow: 'Play now',
    startReplay: 'Start replay',
    startsIn: 'Starts in ',
    days: ' days, ',
    hours: ' hours and',
    minutes: ' minutes',
    counterDays: 'Days',
    counterHours: 'Hours',
    counterMinutes: 'Minutes',
    counterSeconds: 'Seconds',

    //QR Code
    qrInstruction1:
      'Scan the QR code with your smartphone´s camera app and follow the instructions on your mobile phone to register.',
    qrInstruction2: 'and enter the following code:',
    qrInstruction3: 'Or go to',
    expiresIn: 'expires in ',
    qrRefresh: 'Your code has expired. You can still continue on your smartphone without issues.',
    qrRefresh2: 'Could not scan QR code yet? Then please press the button to start again:',

    //Login
    login: 'Login',
    loginAndWatch: 'Log in to watch',
    register: 'Register',
    checkout: 'Checkout',
    selfservice: 'Account',
    logout: 'Logout',
    deleteMyAccount: 'Delete my account',
    deleteMyAccountInfo: 'You are about to delete your account. Are you sure?',
    deleteMyAccountPending: 'Your request is being processed',

    registerCreated: 'Easy Register via smartphone',
    registerCreatedDescription: ``,
    loginCreated: 'Easy Login via smartphone',
    loginCreatedDescription: '',
    checkoutCreated: 'Book pass via smartphone',
    checkoutCreatedDescription: 'Secure your Sportworld pass now from the comfort of your smartphone.',
    selfServiceCreated: 'My Account via smartphone',
    selfServiceCreatedDescription:
      'Scan the QR code displayed with your mobile phone´s camera app and manage your account data securely and quickly on your smartphone.',

    registerEntered: 'Easy Register - Your smartphone is taking over',
    registerEnteredDescription:
      'Quick break for your Smart TV, now you can continue on your mobile. Follow the instructions on your phone, but do not turn off your TV.',
    loginEntered: 'Easy Login - Your smartphone is taking over',
    loginEnteredDescription:
      'A short break for your Smart TV, because now you can continue on your mobile phone. Follow the instructions on your smartphone, but do not switch off your TV.',
    checkoutEntered: 'Your smartphone is taking over',
    checkoutEnteredDescription:
      'A short break for your Smart TV, because now you can continue on your mobile phone. Follow the instructions on your smartphone, but do not switch off your TV.',
    selfServiceEntered: 'My Account - Your smartphone is taking over',
    selfServiceEnteredDescription:
      'A short break for your Smart TV, because now you can continue on your mobile phone. Follow the instructions on your smartphone, but do not switch off your TV.',

    registerSuccess: 'Easy Register success',
    registerSuccessDescription:
      'Great! You are now successfully logged in on your SmartTV. Enjoy the variety of sports and all features in your Sportworld.',
    loginSuccess: 'LOGIN SUCCESFUL',
    loginSuccessDescription: 'You are now logged in on your Smart TV and can get started right away.',
    checkoutSuccess: 'Successfully subscribed',
    checkoutSuccessDescription:
      'Great! You have successfully booked your Sportworld Pass. Enjoy the variety of sports and all the features in your Sportworld.',
    checkoutLoginSuccess: 'Login successful - keep going',
    checkoutLoginSuccessDescription:
      'You are now logged in. Continue the booking process on your smartphone. Follow the instructions on your mobile phone, but do not switch off your TV.',
    selfServiceSuccess: 'My Account successfully handed over',
    selfServiceSuccessDescription:
      'Done. You can now edit your personal data, Sportworld passes and account details from the comfort of your smartphone.',

    errorTitle: 'Sorry, something went wrong...',
    errorLostConnection: `Upps, we've lost the connection to your device.\n Please try to reconnect with your mobile device or computer.`,
    mobileOrComputerLogin: `You can now log in on your mobile device or your computer.\n`,

    //Account
    accountTitle: 'My Account',
    accountDescription:
      'Manage your personal data, passes, and credits conveniently via your smartphone. Use the login button to log in quickly.',

    haveAccount: `Already have an account?`,
    dontHaveAccount: `Don't have an account?`,
    needAccount: 'Use the login button to log in quickly and easily with your smartphone.',

    pleaseAuthenticate: 'Login Now',
    youAreLoggedIn: 'You are now logged in!',
    userId: 'User-Id:',
    accountInstruction1:
      'Use the Account button to create a QR code that will take you directly to your mobile account page.',
    accountInstruction2: 'Alternatively, you can use this mobile page in your browser:',
    accountInstructionUrl: 'https://account.sportworld.app/account',

    personalData: 'Personal Data',
    customerId: 'Customer-ID:',
    eMail: 'E-Mail:',
    paymentData: 'Payment Data',
    noPaymentData: 'No payment data yet',
    address: 'Address',
    billingAddress: 'Billing address:',
    invoices: 'Invoices',
    noInvoices: 'No invoices yet',
    subscriptions: 'Subscriptions',
    allSportsPackage: 'All Sports Package',
    purchased: 'Purchased:',
    creditCard: 'Credit Card:',
    nextBillingDate: 'Your next billing date is',
    editData: 'Edit data',

    // Account Deletion
    accountDeletion: 'Account Deletion',
    accountDeletionDescription1: 'Are you sure you want to delete your account?',
    accountDeletionDescription2: 'If yes, then please send an email to',
    accountDeletionDescription3: `with the context: “Account Deletion”.`,

    //Consent
    consent: 'Consent',
    legitimateInterest: 'Legitimate Interest',
    consentTitle: 'Cookie settings',
    consentDescription: 'Manage consent to third party technologies collecting and processing personal data.',

    //Events
    providerNotAvailable: 'This provider is currently not available in \n Sportworld app',

    //Pages
    contentUnavailable: 'The content currently not available.',
    pageContentTypeUnavailable: 'Page type {{pageType}} is not supported.',
    pagePromotionTokens: 'Promotion Tokens',

    //Stage
    learnMore: 'Learn more',
    redeemVoucher: 'Redeem Voucher',
    stagePromotionTokens: '{{walletName}} tokens: {{count}}',

    //DataWidget
    dataWidgetTypeUnavailable: 'Data widget type {{dataWidgetType}} is not supported.',

    //Subscriptions
    subscriptionUnavailable: 'Subscriptions are not available in your region',
    subscriptionTitle: 'My Sportworld Offers',
    subscriptionDescription: `Your Sportworld Offers are displayed here. Don't have access to exclusive live sport content on Sportworld yet? Then take a look at your booking options now.`,
    alreadyBought: 'Already bought',
    subscribe: 'Subscribe',
    subscribed: 'Subscribed',
    moreInfo: 'More info',

    //Errors
    cantCheckout: `Can't proceed to checkout without any selected offer`,
    appconfigLoadErrorTitle: 'Unable to connect',
    appconfigLoadErrorDescription:
      'Sorry, unfortunately your TV could not connect to the app service due to a technical issue. Please try to connect again.',
    unavailableInRegion: 'Sportworld is unfortunately not available in your region.',

    //DetailsPage
    notWatchable: 'This provider is currently not included in any Sportworld pass. Open the app of ',
    appPoint: ' to watch the event.',
    watchInYour: 'You want to watch this event? Then open the app of ',
    appPoint2: ' when the event starts.',

    //ExternalLinkOverlay
    externalLinkDescription: 'Unfortunately, we cannot play this event in the Sportworld app.',
    externalLinkLiveApp: 'You are about to leave the app and go to an external website',

    //Calendar
    today: 'Today',
    tomorrow: 'Tomorrow',
    unlockPremium: 'Unlock premium',

    //Favorites
    emptyFavorites: 'You do not have any favorites yet',
    addToFavorites: 'Add to favorites',
    favoritesUnavailable: 'Favorites are available for registered users',

    //Sports
    allSports: 'All Sports',
    highlights: 'Highlights',

    //Region page
    regionCardText: `Changing the option may inlfuence the events, videos and channels available to you. It won't change the language of the Sportworld app`,
    change: 'Change',
    availableRegions: 'Available Regions',
    selectRegion: 'Select your region',
    noRegions: 'No regions available',

    //NFT create
    confirm: 'confirm',
    nftExitDialog: 'Du bist gerade dabei, den NFT-Erstellungsassistenten zu verlassen. Bist du dir sicher?',
    aboutMintNft:
      'I understand that my NFT will be minted at the start of the rendering process. Upon completion, my NFT will be unlocked and sent to my registered blockchain wallet. I have read and understand the withdrawal policy, and by agreeing, I forfeit my right to a refund.',
    aboutClosingNft: 'You are about to leave the NFT creation wizard. Are you sure?',
    leaveNft: 'Yes',
    stayNft: 'No',
    startNow: 'Get started',
    bindingBuy: 'Buy',

    //NFT info
    nftMintingFinished: 'Your NFT minting has already finished',
    nftMintingFailed: 'Your NFT minting has failed',
    createNftCubeInfoTitle: 'YOUR MOMENT. YOUR NFT.',
    createNftCubeInfoDescription: 'See an amazing play? Capture it in a unique 3D cube.',
    yourNftMomentInfoTitle: 'CUSTOMIZE YOUR 3D CUBE',
    yourNftMomentInfoDescription: 'Personalize your digital asset by choosing 4 camera feeds and a team page.',
    connectWalletInfoTitle: 'Connect your wallet',
    connectWalletInfoDescription:
      'Link your crypto wallet to your Sportworld account and use your credits to acquire the NFT.',
    secureNftInfoTitle: 'THIS MOMENT IS ALL YOURS',
    secureNftInfoDescription: `We handle the NFT minting for you! Pay in Sportworld Credits and secure a unique NFT that's yours alone and tradeable on marketplaces like OpenSea.`,

    //NFT screens
    nftCreationHeader: 'Sportworld X ELF MyMoment',
    chooseYourSceneTitle: 'PICK YOUR SCENE',
    chooseYourSceneDescription:
      'Define your 6-second highlight moment. Slide the control panel to the desired position in the stream. Preview the scene from different camera angles in the next step.',
    sequenceAvailable: 'This Sequence is still available',
    chooseCamerasTitle: 'Choose your {{camerasCount}} cameras',
    chooseCamerasDescription:
      'Tap on the 4 camera feeds that best showcase your chosen highlight. Hit the "Play" button to review your scene from the selected angle.',
    camerasChosen: 'Cameras Chosen',
    camerasLeft: 'Cameras Left',
    chooseCamerasError: `Unfortunately, we couldn't find any cameras. Please try again later.`,
    customiseCubeTitle: 'INDIVIDUALIZE YOUR CUBE',
    customiseCubeDescription: `Pick your team! Or opt for the neutral team variant. Choose from the three design options and define the cube's final side.`,
    customiseCubeConfirm: 'Ready to finalize your cube, please press confirm to continue',
    customiseCubeBlocked: `Unfortunately, we couldn't find any team logos. Please try again later.`,
    connectWalletTitle: 'Connect your wallet',
    connectWalletDescription:
      'Now link your blockchain wallet to your Sportworld account so we can transfer the NFT to you. Important: Choose the "Polygon Mainnet" as your blockchain network.',
    walletConnected: 'Your wallet is connected',
    connectWalletButton: 'Connect wallet',
    connectWallet: 'Please connect your blockchain wallet',
    useCreditTitle: 'Use your credit',
    useCreditDescription:
      'Redeem a credit worth EUR 133.33 to secure this NFT. If you already have credits, you can initiate the minting process by hitting the "BUY" button. One credit will be automatically deducted.',
    availableCredits: 'You have {{ creditCount }} credit(s) at your disposal',
    buyCredits: 'Buy credits',
    confirmNftMintingStart: 'I agree',
    nftMinting: 'YOUR NFT IS NOW BEING MINTED',
    nftMintingDescription: `Congratulations! In just a few minutes, you'll own a valuable piece of "European League of Football" history. The creation of your 3D cube is rendering and may take up to 30 minutes. Once your NFT is fully minted, we'll display your Contract Address & ID here, which you'll need to view the NFT in your wallet.`,
    contractAddressIdInfo: 'As soon as your contract address and ID are displayed, you can leave the page.',
    nftSuccess: 'YOUR MOMENT IS NOW READY',
    nftSuccessDescription:
      'Well done! A valuable piece of European League of Football history is yours. Rendering process is complete.',
    nftSuccesscontractAddressIdInfo: '',
    contractAddress: 'Contract address',
    contractId: 'ID',
    codeToDisplayNFT: 'Copy your Contract Address and ID into your crypto wallet to show your NFT.',
    backToStream: 'Back to stream',
    nftErrorTitle: 'Oh, something went wrong',
    nftErrorDescription: `Unfortunately, an error has occurred. The reasons can be many, maybe we both lost our internet connection. We are working to ensure that this does not happen again. Don't worry, we haven't charged your credit. Please restart the rendering process.`,
    nftUniqueExitButton: 'Back to Home',
    nftMintingInProgress: 'Your NFT is already in the minting stage.',
    nftMintingConflict: `It looks like an NFT is being created for you. Please wait until your previous NFT has been minted before you can create another one.`,
    nftMintingHasFailed: `Unfortunately, an error has occurred. The reasons can be many, maybe we both lost our internet connection. We are working to ensure that this does not happen again. Don't worry, we haven't charged your credit. Please restart the rendering process.`,
    nftMintingInProgressDescription: 'Your NFT is being minted. Click to see the progress',

    //NFT limited
    nftLimitedCreationHeader: 'Sportworld X ELF Limited',
    price: 'Price',
    limitationNftPieces: 'Limitation: {{nftCount}} item(s)',
    limitation: 'limitation',
    items: 'item(s)',
    connectBlockchainWallet: 'Please connect your blockchain wallet',
    buy: 'Buy',
    processing: 'Processing...',
    confirmBuyNFTTitle: 'Confirm your purchase',
    confirmBuyNFTDescription:
      'I am aware that my NFT will be activated with the purchase and sent to the blockchain wallet I have deposited. I have read the right of withdrawal. I agree to the execution of the contract before the expiry of the withdrawal period and confirm that by my consent I lose my right of withdrawal at the beginning of the execution of the contract and no refund will be made.',
    congratulationsNftPurchase: 'Congratulations, this NFT is yours!',
    purchaseIsNotAvailable: 'Purchase is not available',

    qrTitle: 'NOW SCAN QR CODE in order...',
    qrText1:
      '...to get to your Contract ID and your Contract address. You need these in order to be able to display the NFT in your wallet as well.',
    qrText2: '....To connect the wallet \n ....Buy credits',
    purchasedTitle: 'Congratulations, this NFT is yours!',
    purchasedText1: 'OF THIS NFT, ONLY',
    purchasedText2: 'ITEMS EXIST',
    creditsAmount1: 'You have',
    creditsAmount2: 'Credit(s) available',
    claimErrorTitle: 'NFT Claim Error',
    generalErrorTitle: 'Error',
    walletsErrorDesc: 'Something went wrong. Check your credits and crypto wallet and try again.',
    generalErrorDesc: 'Something went wrong. Please try again later.',

    //Predict
    loginAgain: 'Login again',
    predictLoginError: 'Unfortunately, there was an error loading the prediction game.\nPlease login again.',

    //CopyInput
    copy: 'Copy',
    copied: 'Copied',
    copyInputMessage: '{{type}} is copied to your clipboard',

    // ForceUpdate
    update: 'Update',
    closeTheApp: 'Close',
    forceUpdateDescriptionTizen:
      'This version of Sportworld is no longer supported. Please update to a new version in Tizen App Store.',
    forceUpdateDescriptionMobile:
      'This version of Sportworld is no longer supported. Please update to a new version in App Store.',
    forceUpdateDescriptionIOS:
      'This version of Sportworld is no longer supported. Please update to a new version in App Store.',
    forceUpdateDescriptionAndroid:
      'This version of Sportworld is no longer supported. Please update to a new version in Play Market.',

    soccerData: {
      toLiveStreamButtonText: 'To Live Stream',
      matches: {
        vs: 'VS.',
        noDate: 'Date in not available',
        noData: {
          text: 'There are no matches played this week',
        },
        tournamentNotStarted: {
          text: '{{name}} has not started yet...',
          button: 'Go to the first week',
        },
        tournamentFinished: {
          text: '{{name}} has already finished...',
          button: 'Go to the last week',
        },
      },
      standings: {
        noData: {
          text: 'No standings information available',
        },
      },
    },

    search: {
      title: 'Search results',
      errorText: 'Something went wrong...',
      suggestions: 'Suggestions',
      noSuggestionsText: 'No suggestions found',
      input: {
        placeholder: 'Search',
      },
      lines: {
        noDataText: 'No results found',
      },
      itemsList: {
        noItemsText: 'No {{items}} found',
        event: 'events',
        page: 'pages',
      },
      tabs: ['Events', 'Pages'],
    },
    detailPage: {
      eventNotFound: 'Content is no longer available',
      unhandledError: 'Something went wrong',
      goHome: 'Go to Home page',
      watchForSamsungCredits: 'Unlock now',
      watchForSamsungCredits_plural: 'Unlock now',
      information: {
        purchaseByCredits:
          'Get access to the live event now for <span>{{cost}} Credit</span> (equals €\u00a0{{euro}}).',
        purchaseByCredits_plural:
          'Get access to the live event now for <span>{{cost}} Credits</span> (equals €\u00a0{{euro}}).',
        redirectToChanel:
          'This program is broadcasted on {{-providerName}}. You will be directly redirected to the TV channel.',
        availableInApp: 'This program is only available through {{-providerName}}. You may need a subscription.',
        liveUnavailable:
          'The event is live, but not yet available in Sportworld. Stay tuned for updates on when it will be available here.',
        upcomingUnavailable:
          'This event is starting soon, but is not yet available on us. We are working on offering the channel soon.',
        loginToWatch: 'Log in to watch this program. You may need a Sportworld Pass.',
        freeChannel: 'Watch live! This event is currently running - and you can be there for free!',
        availablePremiumChannel: 'You are unlocked for this event. Join live!',
        futureAvailablePremium:
          'You are already unlocked. The countdown is running – you´ll be able to watch the event soon.',
        needSubscription:
          'The event is live! Tune in now and experience the spectacle. You need a subscription to watch the game.',
        waitCountdownEnds: `The event starts soon and you can be there for free! Don't miss it!`,
        waitCountdownEndsPremium: `Coming soon! Get your subscription in time so you don't miss the event.`,
        premiumPackIsRequired: 'A PREMIUM PACK is required to play this content.',
        scanQr:
          'A PREMIUM PACK is required to play this content. Please scan the QR code to manage your subscriptions and order the required package if necessary.',
      },
    },
    ppvPopup: {
      buttonGetMoreCredits: 'Get more credits',
      purchased: 'Purchased',
      payPerView: 'Pay Per View',
      promotion: 'Promotion',
      orderOverview: 'Order overview',
      redeemCredit: 'UNLOCK NOW',
      credit: 'Credit',
      credit_plural: 'Credits',
      toEvent: 'To event',
      watchLater: 'Watch later',
      successfulPurchase: 'Your purchase was successful.',
      agreement:
        'By clicking "Unlock Now", the event will be available to you, and you agree that no refunds are possible once the event has been viewed or downloaded. By purchasing or playing you agree to our terms and conditions on sportworld.app. Sold by B1SmartTV GmbH.',
      isNotEnoughCredits:
        'Unfortunately, your credit balance is not sufficient for this event. Scan the QR-code to top up your credit balance.',
      actualCredits: '{{creditsName}}-Credits',
      requiredCredits: 'Required {{creditsName}}-Credits',
      creditsLeftAfterPurchase: '{{creditsName}}-Credits after purchase',
      selectCredits: 'Select credits to redeem',
      redeemFailed: 'Something went wrong.',
      redeemFailedInfo: 'Unfortunately, something went wrong while redeeming your credits.\nPlease try again.',
      eventAlreadyRunning: 'The event is already running',
      warningInfo:
        'The live event <span>{{name}}</span> started <span>at {{startTime}}</span> and will run <span>until {{endTime}}</span>. You can join live from the current time, but you cannot start from the beginning.',
      warningInfo2: 'Would you still like to redeem your credits for the event?',
    },
    pageFallback: {
      content: 'This page is currently unavailable.\nTry to reload it or go back to Home page.',
      buttons: ['Retry', 'Home'],
    },
    toasts: {
      sessionExpired: 'Your session has expired, please login again.',
      promotionLaunchFailed:
        'PromotionApp not found: {{promotionAppID}}. Please check your promotion app is installed.',
      appNotFound: '{{appName}} was not found. Please check if the app is installed.',
      configIsNotAccessible: 'Application config is not accessible, some functionality may be limited.',
      favoriteIsUnavailable: 'Favorites is currently not available.',
    },
    tune: {
      noChannels: 'No channels found',
      noChannel: 'Can not find channel for tune',
      cantTune: 'Can not tune to TV channel',
    },
    dataWidget: {
      standing: {
        pl: 'PL',
        team: 'Team',
        mp: 'Mp',
        md: 'MD',
        w: 'W',
        d: 'D',
        l: 'L',
        goals: 'Goals',
        gd: 'Gd',
        pts: 'Pts',
      },
      commentary: {
        'noData': 'There are no matches in this time period',
        'matchStartsAt': 'This match will start at',
        'matchStarts': 'This match will start',
        'noCommenteryData': 'There is no live ticker for this match',
        'backToOverview': 'Back to overview',
        'minute': 'Minute',
        'assist': 'Assist',
        'attempt blocked': 'Attempt Blocked',
        'attempt saved': 'Attempt Saved',
        'comment': 'Comment',
        'comment_auto': 'Auto Comment',
        'comment_important': 'Important Comment',
        'comment_mixed': 'Mixed Comment',
        'contentious referee decisions': 'Contentious Referee Decisions',
        'corner': 'Corner',
        'Deleted after review': 'Deleted After Review',
        'end 1': 'End of First Half',
        'end 2': 'End of Second Half',
        'end 3': 'End of Extra Time - First Half',
        'end 4': 'End of Extra Time - second Half',
        'end 5': 'End of Penalty Shootout',
        'end 10': 'End of Half Time',
        'end 11': 'End of Second Half - Before Extra Time',
        'end 12': 'Extra Time - Half Time',
        'end 13': 'End of Extra Time - Before Penalties',
        'end 14': 'End of Full Time',
        'end 16': 'End of Pre-Match',
        'end delay': 'End Delay',
        'free kick lost': 'Free Kick',
        'free kick won': 'Free Kick',
        'full time': 'Full Time',
        'goal': 'Gooaal!',
        'half time': 'Half Time',
        'half_time summary': 'Half Time Summary',
        'highlight': 'Highlight',
        'kick off': 'Kick Off',
        'lineup': 'Lineup',
        'miss': 'Miss',
        'offside': 'Offside',
        'own goal': 'Own Goal',
        'penalty': 'Penalty',
        'penalty goal': 'Penalty Goal!',
        'penalty lost': 'Penalty',
        'penalty miss': 'Penalty Missed',
        'penalty_so goal': 'Penalty Goal!',
        'penalty_so miss': 'Penalty Missed',
        'penalty save': 'Penalty Save',
        'penalty saved': 'Penalty Saved',
        'penalty won': 'Penalty',
        'player retired': 'Player Retired',
        'post': 'Post',
        'postponed': 'Postponed',
        'post-match summary': 'Post-Match Summary',
        'pre kick off': 'Pre Kiick Off',
        'red card': 'Red Card',
        'second half': 'Second Half',
        'secondyellow card': 'Second yellow Card',
        'second_yellow red card': 'Red Card',
        'start': 'Start',
        'start delay': 'Start Delay',
        'stats': 'Stats',
        'substitution': 'Substitution',
        'team news': 'Team News',
        'var': 'Video Assistant Referee',
        'yellow card': 'Yellow Card',
        'VAR cancelled goal': 'Goal cancelled by VAR',
      },
    },

    // Feature Screen
    featureScreen: {
      continueToSportWorld: 'continue to Sportworld',
      goToChannel: 'go to channel',
    },
    // Payment Popup
    paymentPopup: {
      title: 'Choose payment method',
      yourCredits: 'Your Credits: {{credits}}',
      purchaseByCredits: 'Unlock event for <span>{{cost}} Credit</span>',
      purchaseByCredits_plural: 'Unlock event for <span>{{cost}} Credits</span>',
      continueWithCredits: 'Continue with Credits',
    },
    smartAppBanner: {
      view: 'View',
      free: 'FREE',
      appStore: 'On the App Store',
      googlePlay: 'In Google Play',
    },
  },
}
